import { Component, OnInit, Inject, TemplateRef, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { GoogleIdentityService } from 'src/app/services/google-identity.service';
import { environment } from 'src/environments/environment';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { AuthenticationService } from '../../services/authentication.service';
import {
   AuthenticateModel, ExternalAuthDto, LoginUser, TermsAndConditions
} from '../../services/webapiclient.service';
import { TermsService } from '../../services/terms.service';
//import { ConsoleReporter } from 'jasmine';

/**
  * Bejelentkezés.
  * Új jelszó igénylése belépési név alapján. (elfelejtett jelszó)
  * Új regisztráció indítása (átirányítás a regisztrációs komponensre)
  */
@Component({
   selector: 'app-login', templateUrl: 'login.component.html',
   standalone: false
})
export class LoginComponent implements OnInit {
   showSocialLogin: boolean = true;
   loginForm: UntypedFormGroup;
   loading = false;
   modalLoading = false;
   submitted = false;
   returnUrl: string;
   error = '';
   googleToken: any;
   modalError = '';
   authenticateModel: AuthenticateModel = {} as AuthenticateModel;
   @ViewChild('resetPasswordtmpl', { static: true }) resetPasswordtmpl: TemplateRef<any>;
   @ViewChild('resetPasswordConfirmtmpl', { static: true }) resetPasswordConfirmtmpl: TemplateRef<any>;
   @ViewChild('termInfo', { static: true }) termInfo: TemplateRef<any>;
   @ViewChild('googleBtnContainer', { static: false }) buttonContainer!: ElementRef;

   //Google ClientId
   googleClientId = `${environment.googleClientId}`;

   modalRef: BsModalRef;
   confirmModalRef: BsModalRef;

   needAcceptance: Boolean = false;
   actualTerms: any;
   currentUser: LoginUser;

   userName = '';

   authDTO: ExternalAuthDto = <ExternalAuthDto>{};;

   constructor(
      @Inject(L10N_LOCALE) public locale: L10nLocale,
      private google: GoogleIdentityService,
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private termsService: TermsService,
      private authenticationService: AuthenticationService,
      private modalService: BsModalService
   ) {
      // // redirect to home if already logged in
      // if (this.authenticationService.currentUserValue &&
      //    this.authenticationService.currentUserValue.error === null) {
      //       this.authenticationService.logout();
      //       //this.router.navigate(['/']);
      // }
   }

   async ngOnInit() {

      //this.showSocialLogin = this.route.snapshot.queryParamMap.get('showSocialLogin') === 'true';  
      this.showSocialLogin = true;   
      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

      this.currentUser = this.authenticationService.currentUserValue;
      //console.log(this.currentUser);
      if (this.currentUser && this.currentUser.displayName != null) {
         //Már be van lépve a felhasználó
         //Megnézzük, hogy nem járt-e le a token
         const jwtToken = JSON.parse(atob(this.currentUser.token.split('.')[1]));
         const expires = new Date(jwtToken.exp * 1000);
         // console.log(expires,new Date());
         // console.log(expires < new Date());
         if (expires < new Date()) {
            //Lejárt a token, frissítünk
            this.authenticationService.refreshToken().subscribe({
               next: (result) => {
                  if (result && result != null && result.token != null) {
                     //Sikeres frissítés, átirányítjuk a fő oldalra
                     this.router.navigate(['/']);
                  } else {
                     this.authenticationService.logout();
                  }
               },
               error: (e) => { this.authenticationService.logout(); }
            });
         } else {
            //Jó a token
            if (this.returnUrl != "/error") {
               //Nem hiba miatt vagyunk itt
               this.router.navigate([this.returnUrl]);
            }
         }
      }


      this.loginForm = this.formBuilder.group({
         username: ['', Validators.required],
         password: ['', Validators.required],
         acceptConditions: ['']
      });

      this.f['acceptConditions'].setValue(false);

      await this.google.load();
      this.launchGoogleLogin();
   }

   // convenience getter for easy access to form fields
   get f() { return this.loginForm.controls; }

   onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
         return;
      }

      this.loading = true;
      this.authenticateModel.password = this.f.password.value;
      this.authenticateModel.username = this.f.username.value;
      this.authenticateModel.acceptConditions = this.f.acceptConditions.value;

      if (this.authenticateModel.acceptConditions == null) {
         this.authenticateModel.acceptConditions = false;
      }
      this.authenticationService.login(this.authenticateModel).then(data => {
         this.router.navigate([this.returnUrl]);
      }).catch(err => {
         this.error = err;
         //Ha új ÁSZF van, akkor el kell fogadni.
         if (err == "Core.NewTerms") this.needAcceptance = true;
         this.loading = false;
      });
   }


   kamu() {
      this.authDTO.provider = 'c8852cbe3f52941e385d0553585394e55.0.pwur.1Z1p6nNSAhc33P12vCxtEw';
      this.authDTO.idToken = "eyJraWQiOiJhVmVIRmFXeEFaIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLnByZWRlbXBsYXRmb3JtLmFwcHRlc3p0IiwiZXhwIjoxNzYxMDQyNjE5LCJpYXQiOjE3NjA5NTYyMTksInN1YiI6IjAwMDY0MS45Y2VkMDFiOWIzMjU0ZmUxOTdkNjljZDEyMzViMGZjZi4wOTIwIiwiY19oYXNoIjoiWWZjQ09KVVFEM3JlTkpudnhXV044dyIsImVtYWlsIjoiaGFuemlrLmJlbGFAbmV0aXMuaHUiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXV0aF90aW1lIjoxNzYwOTU2MjE5LCJub25jZV9zdXBwb3J0ZWQiOnRydWV9.JcbV5rqEhTCNTVlFmNzAfu3Uvvbb1Cz7XZub9O76K0-0QqYG_sNKkZAR9BlU09SmZZdPQbdGe37YQ5tjgPc0L1vS975X4izUNzp3D1AhAlMqOQLmwzYd-H6MAgWUzz8ojm3EgHn_nGnEOPgJ1vdTohq0ViPuyZ5b7c-ajmHwIYUmG5j2VKG62Q9UPykzsiIE4lT_TZP5u-8ZQhog4FGZv7Z6iwYfD-_5HhJdRQoYbJBzIxyCkSPYZ-SzfH8togI_9ha5KOSwydk_I0CO-tQ26hU6o4eczL9h7JgAbvH1XySWsp854SUwrLAYlUa6ISSjyBTuAQ4a6Oj5onzW4ky5mQ";
      // this.authDTO.email = "hanzik.bela@netis.hu";
      // this.authDTO.firstName = "Béla";
      // this.authDTO.lastName = "Hanzik";
      // Küldd a token-t a backend-nek validálásra
      this.authenticationService.appleLogin(this.authDTO).then(data => {
         this.router.navigate(['/home']);
      }).catch(err => {
         this.error = err;
         // //Ha új ÁSZF van, akkor el kell fogadni.
         // if (err == "Core.NewTerms") this.needAcceptance = true;
         // this.loading = false;
      });
   }

   resetPassword() {
      this.modalRef = this.modalService.show(this.resetPasswordtmpl, { backdrop: 'static', keyboard: false });
   }

   closeModal() {
      //this.clearError();
      this.modalRef.hide();
   }

   //ÁSZF megtekintése
   getTermsInfo() {
      this.termsService.getActualTerms().then(
         result => {
            this.actualTerms = <TermsAndConditions>result;
            this.modalRef = this.modalService.show(this.termInfo, { class: 'modal-lg', backdrop: 'static', keyboard: false });
         }
      ).catch(err => {
         this.error = err;
      });

   }

   launchFbLogin() {
      this.router.navigate(['/facebook-login']);
   }
   launchGoogleLogin() {
      this.google.initialize(this.googleClientId, (idToken: string) => {
         if (idToken) {
            this.googleToken = idToken;
            this.authDTO.provider = 'Google';
            this.authDTO.idToken = idToken;
            // Backend ellenőrzés
            this.authenticationService.googleLogin(this.authDTO).then(data => {
               this.router.navigate(['/home']);
            }).catch(err => {
               this.error = err;
               // //Ha új ÁSZF van, akkor el kell fogadni.
               // if (err == "Core.NewTerms") this.needAcceptance = true;
               // this.loading = false;
            });
         }

      });

      this.google.renderButton(this.buttonContainer.nativeElement);

      if (this.googleToken) {
         this.google.prompt();
      }


   }

   resetPasswordSubmit(userName: string) {
      this.modalError = "";
      this.modalLoading = true;
      this.authenticationService.forgotPassword(userName).then(
         result => {
            this.modalLoading = false;
            this.closeModal();
            this.modalRef = this.modalService.show(this.resetPasswordConfirmtmpl, { backdrop: 'static', keyboard: false });

            //this.cdr.markForCheck();
         }

      ).catch(err => {
         this.modalError = err;
         this.modalLoading = false;
         //this.cdr.markForCheck();
      });
   }

   registration() {
      this.router.navigate(['/registration']);
   }

}
